var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchIcon = function SvgSearchIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 16.2988L13.3477 12.373C14.1973 11.3477 14.666 10.0293 14.666 8.59375C14.666 5.25391 11.9121 2.5 8.57227 2.5C5.20312 2.5 2.50781 5.25391 2.50781 8.59375C2.50781 11.9629 5.23242 14.6875 8.57227 14.6875C9.97852 14.6875 11.2969 14.2188 12.3516 13.3691L16.2773 17.2949C16.4238 17.4414 16.5996 17.5 16.8047 17.5C16.9805 17.5 17.1562 17.4414 17.2734 17.2949C17.5664 17.0312 17.5664 16.5918 17.2734 16.2988ZM3.91406 8.59375C3.91406 6.01562 5.99414 3.90625 8.60156 3.90625C11.1797 3.90625 13.2891 6.01562 13.2891 8.59375C13.2891 11.2012 11.1797 13.2812 8.60156 13.2812C5.99414 13.2812 3.91406 11.2012 3.91406 8.59375Z",
    fill: "#667085"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search-icon.98513425bf8da11849b5d68e52745669.svg";